import { Link } from "react-router-dom";
import { InstagramLogo, TiktokLogo, YoutubeLogo, FacebookLogo } from "@phosphor-icons/react";
import { fileUrl } from "../../lib/api";
import { useLang } from "../../i18n";

export default function Footer({ settings }) {
    const { t } = useLang();
    const socials = [
        { key: "instagram", icon: InstagramLogo },
        { key: "tiktok", icon: TiktokLogo },
        { key: "youtube", icon: YoutubeLogo },
        { key: "facebook", icon: FacebookLogo },
    ].filter((s) => settings[s.key]);

    return (
        <footer className="border-t border-racing-line py-14" data-testid="main-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div>
                    <div className="flex items-center gap-3">
                        <Link to="/" title="Kembali ke Halaman Utama" className="w-9 h-9 bg-racing-red flex items-center justify-center hover:bg-racing-redhover transition-colors" data-testid="footer-logo">
                            {settings.logo_url ? (
                                <img src={fileUrl(settings.logo_url)} alt="Logo Mandalika Inlineskate" className="w-[80%] h-[80%] object-contain" />
                            ) : (
                                <span className="font-display text-white text-xl leading-none">M</span>
                            )}
                        </Link>
                        <span className="font-display uppercase tracking-wide text-neutral-900">Mandalika Inlineskate</span>
                    </div>
                    <p className="mt-4 text-sm font-light text-racing-muted max-w-sm">
                        {t.footer_tagline}
                    </p>
                </div>

                <div className="flex items-center gap-5">
                    {socials.map((s) => (
                        <a
                            key={s.key}
                            href={settings[s.key]}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`footer-social-${s.key}`}
                            className="text-racing-muted hover:text-racing-red transition-colors duration-300"
                            aria-label={s.key}
                        >
                            <s.icon size={24} weight="duotone" />
                        </a>
                    ))}
                    <Link
                        to="/admin/login"
                        data-testid="footer-admin-link"
                        className="ml-4 text-[10px] uppercase tracking-[0.25em] text-racing-muted hover:text-racing-red transition-colors duration-300 border border-racing-line px-3 py-2"
                    >
                        Admin
                    </Link>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-6 md:px-10 mt-10 pt-6 border-t border-racing-line">
                <p className="text-xs text-racing-muted/60">{t.footer_rights}</p>
            </div>
        </footer>
    );
}
